// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Yz2KG","banner":"Header_banner__h8fbJ"};